// @flow
import React from 'react';
import DefaultTheme from './theme';
/*::
import type { SimpleCardThemeType } from './theme';
import type { Node } from 'react';

export type Props = {|
  text: string,
  linkLabel: string,
  linkTo?: string,
  linkComponent?: Node;
  children?: Node,
  theme?: SimpleCardThemeType,
|}
*/

var SimpleCard = function SimpleCard(_ref
/*: Props */
) {
  var _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text,
      _ref$linkLabel = _ref.linkLabel,
      linkLabel = _ref$linkLabel === void 0 ? '' : _ref$linkLabel,
      _ref$linkTo = _ref.linkTo,
      linkTo = _ref$linkTo === void 0 ? '#' : _ref$linkTo,
      _ref$linkComponent = _ref.linkComponent,
      linkComponent = _ref$linkComponent === void 0 ? 'a' : _ref$linkComponent,
      children = _ref.children,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? DefaultTheme : _ref$theme;
  return /*#__PURE__*/React.createElement(theme.Main, null, React.Children.only(children), /*#__PURE__*/React.createElement(theme.Gradient, null), /*#__PURE__*/React.createElement(theme.TextWrapper, null, /*#__PURE__*/React.createElement(theme.Text, {
    as: linkComponent,
    to: linkTo,
    href: linkTo
  }, text)), /*#__PURE__*/React.createElement(theme.Link, {
    as: linkComponent,
    to: linkTo,
    href: linkTo
  }, linkLabel, /*#__PURE__*/React.createElement(theme.Arrow, null)));
};

export default SimpleCard;